<template>
  <div>
    <template v-if="$store.getters.getShowNav">
      <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
        <a class="navbar-brand" href="/dashboard">{{appName}}</a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav" v-if="Object.keys(user).length > 0">
          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link class="nav-link" to="/announcements">Edit Announcements</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/programme">Edit Programme</router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link class="nav-link" to="/notification">Send Notification</router-link>
            </li> -->
          </ul>
        </div>
        <ul class="nav navbar-nav navbar-right">
          <li class="nav-item">
            <button
              type="button"
              class="btn btn-link"
              v-if="Object.keys(user).length > 0"
              @click="signOut"
            >Sign Out</button>
          </li>
        </ul>
      </nav>
    </template>
    <template v-if="!$store.getters.getShowNav">
      <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
        <a class="navbar-brand" href="/">Braeton SDA Church</a>
      </nav>
    </template>
  </div>
</template>
<script>
import { signOut } from "../db.js";
import CONSTANTS from "../constants.js";

export default {
  name: "Nav",
  props: {
    user: Object,
    appName: String
  },
  methods: {
    signOut() {
      signOut().catch(() => this.$toast.open(CONSTANTS.toastObject));
      this.$store.dispatch("purgeUser");
      this.$router.replace("admin");
    }
  }
};
</script>
<style lang="scss" scoped>
nav {
  margin-bottom: 20px;
}
</style>